import { Link } from "react-router-dom";
import React from "react";
import config from "../config";

interface PolicyLinkProps {
    id: number;
    name: string | number;
    target?: string;
    className?: string;
    business?: string;
}

const PolicyLink: React.FC<PolicyLinkProps> = ({ id, name, target, className, business }) => {
    if (business === "Trust") {
        const url = `${config.connectWebUrl}/TrustManagement/Policy.aspx?id=${id}`;
        return (
            <a href={url} rel="noreferrer noopener" target="_blank" className={className || "blue-link"}>
                {name}
            </a>
        );
    }

    return (
        <Link to={`/policy/${id}`} target={target || "_blank"} className={className || "blue-link"}>
            {name}
        </Link>
    );
};

export default PolicyLink;
